require('es6-promise').polyfill();
import axios from 'axios';
import Utilities from './utilities';

export default {
  getVisitorID (cb_success, cb_failure) {
    axios.get(Utilities.apiURL() + 'visitor')
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },
  infoModule (module_id, cb_success, cb_failure) {
    axios.get(Utilities.apiURL() + 'module/' + module_id)
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  },
  redirectPayment (module_id, visitor_id, gateway_type, installment, multiplier, is_partial, fields, vendor_id, affiliate_id, shipping_id, cb_success, cb_failure) {
    let data = {
      module_id: module_id,
      visitor_id: visitor_id,
      gateway_type: gateway_type,
      installment: installment,
      multiplier: multiplier,
      data_payment: is_partial,
      form: fields,
      vendor_id: vendor_id,
      affiliate_id: affiliate_id,
      shipping_id: shipping_id
    };

    console.log('redirectPayment with data: ', data);

    axios.post(Utilities.apiURL() + 'order', data)
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        // console.log(response);
        cb_failure(error);
      });
  },
  infoUrl (data, cb_success, cb_failure) {
    axios.post(Utilities.apiURL() + 'module/url', data)
      .then(function (response) {
        cb_success(response);
      })
      .catch(function (error) {
        cb_failure(error);
      });
  }
};



// WEBPACK FOOTER //
// ./src/api/module.js